import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandshake, faCalendar, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import Fade from 'react-reveal/Fade';
const styles = theme => ({

})
class Services extends React.Component{
    constructor(props){
        super(props);
        this.state = {
         services:[
             { 
                icon: faHandshake, 
                title: 'Online Marketing', 
                description: "Duwun is the thought leader in Digital Marketing and has done the most cost efficient paid campaigns ever in Myanmar. Our team member occasionally teaches at marketing institutions.",
                delay: 100
            },
            { 
                icon: faCalendar, 
                title: 'Event activation', 
                description: "Duwun has one of the best event team to activate a large scale event with more than 40,000 attendants. Work with Duwun to activate your brand.",
                delay: 300
            },
            { 
                icon: faThumbsUp, 
                title: 'Digital', 
                description: "The word Digital in Myanmar is synonymous with Duwun. Because we are the first true digital media covering stories in both article and video optimized for digital. We respect the digital as a new medium and adjust our content accordingly to maximize the consumption rate.",
                delay: 500
            }
            ]
        };
      }  
    render(){
        const { classes } = this.props;
        return(
            <Grid container  
            direction="row"
            justify="center"
            alignItems="center"
            className="service advertise-layout"
            >
            <Grid item md={12} xs={12} >
                <h2 style={{ padding: '30px 0px 10px', color: '#ed7123', fontSize: 30 }}> Expertise and other services</h2>
            </Grid>
            {
                this.state.services.map((item, i) => {
                    return(
                        <React.Fragment key={i}>
                            <Grid item md={12} xs={12}>
                            <Fade left delay={item.delay} duration={1500}>
                            <Grid container style={{ margin: '20px 0px' }} >
                            <Grid item md={3} xs={12} className="content">
                                {/* <Fade left delay={item.delay} duration={1500}> */}
                                    <Avatar className='title' style={{ width: 100, height: 100 }}>
                                        <p>
                                            <FontAwesomeIcon icon={item.icon}></FontAwesomeIcon>
                                        </p>
                                    </Avatar>
                                {/* </Fade> */}
                            </Grid>
                                <Grid item md={9} xs={12} >
                                    {/* <Fade left delay={item.delay} duration={1500}> */}
                                        <h3>{item.title}</h3>
                                        <p style={{ textIndent: 50 }}>{item.description}</p>
                                    {/* </Fade> */}
                                </Grid> 
                                <Divider className="customHr" />  
                                </Grid>
                                </Fade> 
                            </Grid>
                        </React.Fragment>
                    )
                })
            }
             
           </Grid>
        )
    }
}
export default withStyles(styles)(Services);